import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetBankAccountConfirmedActivitiesRequest,
  DefaultApiBankAccountActivitiesWithdrawalReserveRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getBankAccountConfirmedActivities = async (
  instance: AxiosInstance,
  params: DefaultApiGetBankAccountConfirmedActivitiesRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getBankAccountConfirmedActivities(params)
}

export const bankAccountActivitiesWithdrawalReserve = async (
  instance: AxiosInstance,
  params: DefaultApiBankAccountActivitiesWithdrawalReserveRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).bankAccountActivitiesWithdrawalReserve(params)
}

// Do Not Remove this line ===@import api client===
